import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Modal from '../../overlays/modal';
import AgreeToTerms from '../../ui_kit/utilities/agree_to_terms';
import Context from '../../../utils/context';

export default function AcceptPrivacyModal() {
  let location = useLocation();
  const context = useContext(Context);
  const [showAcceptPrivacyModal, setShowAcceptPrivacyModal] = useState(false);
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);

  const onPrivacyContinue = (e) => {
    if (!acceptedPrivacy) {
      e.preventDefault();
      return;
    }
    setShowAcceptPrivacyModal(false);
    context.auth.userUpdate({ accepted_privacy: true });
  };

  useEffect(() => {
    if (
      context.auth.isLoggedIn() &&
      !context.auth.getCurrentUser().accepted_privacy &&
      !context.auth.isImpersonating() &&
      !context.auth.isSuperUser()
    ) {
      setShowAcceptPrivacyModal(true);
    }
  }, [location]);

  return (
    <>
      {showAcceptPrivacyModal && (
        <Modal
          className='pp-modal'
          content={
            <div className='text-center'>
              <h2 className='privacy-header'>Changes to our Terms of Use</h2>
              <p>
                PatientPartner has updated the{' '}
                <Link target='_blank' to='/terms' className='terms-link' style={{ color: '#73CCD3 ' }}>
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link target='_blank' to='/privacy' className='terms-link' style={{ color: '#73CCD3' }}>
                  Privacy Policy and Authorizations
                </Link>
                . Please read and agree to the updated policies.
              </p>
              <AgreeToTerms acceptedTerms={acceptedPrivacy} setAcceptedTerms={setAcceptedPrivacy} />
              <button disabled={!acceptedPrivacy} className='wb-cta' onClick={(e) => onPrivacyContinue(e)}>
                Continue
              </button>
            </div>
          }
          hideClose
          backdrop={`static`}
        />
      )}
    </>
  );
}
